import React from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import RateListFilter from "./RateListFilter";
import Card from "../Reusable/Card";
import DeliveryChargeTable from "./DeliveryChargeTable";
import CustomerContact from "./CustomerContact";
import { getKey } from "../../helpers/sessionKey";
import CargoDeliveryChargeTable from "./CargoDeliveryCharge";

const Rate = ({
  profile,
  cityContactData,
  currentClient,
  branchContactData,
  handleUpdateContact,
}) => {
  const clientType = getKey("client-type");
  const filterForm = useForm({
    defaultValues: {
      local_branch: profile?.service_branch[0],
      local_service: profile?.default_service_type ?? profile?.service_type[0],
      ...(clientType === "cargo"
        ? null
        : {
            localProduct_type: profile?.product_type?.map(
              (item: Record<string, string>) => ({
                label: item?.name,
                value: item?.id,
              })
            ),
          }),
    },
  });

  const { local_branch, local_service, localProduct_type } = useWatch({
    control: filterForm.control,
  });

  return (
    <>
      <FormProvider {...filterForm}>
        <RateListFilter profile={profile} clientType={clientType} />
      </FormProvider>

      {clientType === "cargo" ? (
        <Card title={`Rate Format`}>
          {local_branch &&
          local_service &&
          localProduct_type?.length !== 0 &&
          localProduct_type ? (
            <CargoDeliveryChargeTable
              localServiceBranch={local_branch}
              localServiceType={local_service}
              localProductType={localProduct_type}
              merchantId={profile?.id}
            />
          ) : (
            <>
              {" "}
              <p>Please select Service Branch And Service type</p>
            </>
          )}
        </Card>
      ) : (
        <Card title={`Rate Format`}>
          {local_branch &&
          local_service &&
          localProduct_type?.length !== 0 &&
          localProduct_type ? (
            <DeliveryChargeTable
              localServiceBranch={local_branch}
              localServiceType={local_service}
              localProductType={localProduct_type}
              merchantId={profile?.id}
            />
          ) : (
            <p>Please select Service Branch And Service type</p>
          )}
        </Card>
      )}
      {currentClient?.business_name === "Kontract Transport Pvt. Ltd." ? (
        <>
          <Card title="Sender Branch Wise Contact">
            <CustomerContact
              contactData={branchContactData ?? []}
              label={"Branch Name"}
              handleUpdateContact={handleUpdateContact}
              branch={true}
              city={false}
            />
          </Card>
          <Card title="Receiver City Wise Contact">
            <CustomerContact
              contactData={cityContactData ?? []}
              label={"City Name"}
              handleUpdateContact={handleUpdateContact}
              city={true}
              branch={false}
            />
          </Card>
        </>
      ) : null}
    </>
  );
};

export default Rate;
